import React from 'react';

import {useTranslation} from 'react-i18next';

import {Pressable, XStack, Typography, BidirectionalIcon, IconView, Trans} from '@medad-sep/core';
import {useLanguageSwitcher} from '@medad-sep/shell-default/hooks/useLanguageSwitcher';

type Props = {
  onPressLanguage?: () => void;
};

export const LanguageSelectorBase: React.FC<Props & {children: React.ReactNode}> = ({children, onPressLanguage}) => {
  const {toggleLanguage} = useLanguageSwitcher();

  return (
    <Pressable width="100%" onPress={toggleLanguage} onPressOut={onPressLanguage}>
      {children}
    </Pressable>
  );
};

export const LanguageLabel: React.FC<Props> = ({onPressLanguage}) => {
  const {i18n} = useTranslation();

  return (
    <LanguageSelectorBase onPressLanguage={onPressLanguage}>
      <XStack
        width="100%"
        height={40}
        paddingHorizontal="$spacing-xl"
        gap="$spacing-sm"
        justifyContent="space-between"
        alignItems="center"
        borderRadius="$rounded-lg">
        <XStack gap="$spacing-md" alignItems="center">
          <IconView icon="LanguageSquareIcon" size={20} color="$nav-item-icon-fg" />
          <Typography fontSize="$text-sm" fontWeight="600" color="$text-secondary">
            <Trans i18nKey="language.label" />
          </Typography>
        </XStack>
        <XStack alignItems="center" gap="$spacing-lg">
          <Typography fontSize="$text-xs" fontWeight="500" color="$text-quaternary">
            <Trans i18nKey={`language.${i18n.language}`} />
          </Typography>
          <BidirectionalIcon size={16} color="$fg-quaternary" icon="ArrowRight01Icon" />
        </XStack>
      </XStack>
    </LanguageSelectorBase>
  );
};
